const urlAdmin = process.env.REACT_APP_SERVER_URL_ADMIN

export const WorkTgsMocks: {[key: string]: any} = {
    [`${urlAdmin}/api/v1/work_tgs`]: {
        work_tgs: [
            {id: 1, name: '@maxim_jordan'},
            {id: 2, name: '@danzelVash'},
            {id: 3, name: '@kalashnikoff069'},
            {id: 4, name: '@tg_math_admin'},
            {id: 5, name: '@tg_support_team'},
        ]
    },
    [`${urlAdmin}/api/v1/work_tgs/:id`]: {
        work_tg: {id: 1, name: '@maxim_jordan'}
    },
    [`${urlAdmin}/api/v1/work_tgs/:id/delete`]: {}
}
